module.exports = __webpack_public_path__ + "static/media/web-design.976ebeb8.png";